var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJouranl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.09 14.696C16.5753 15.363 15.368 16.5768 14.709 18.095L18.979 18.978L18.093 14.696H18.09ZM2.475 8.317L0 5.85C1.13054 3.23323 3.21149 1.14264 5.823 0L5.829 0L8.298 2.463C9.70704 1.85405 11.226 1.54059 12.761 1.542C18.967 1.542 24 6.569 24 12.771C24 18.973 18.967 24 12.761 24C6.551 24 1.52 18.976 1.52 12.771C1.52 11.18 1.875 9.69 2.472 8.32L11.615 17.434C12.7461 14.8176 14.8269 12.7272 17.438 11.584L8.303 2.464H8.295C5.68492 3.60873 3.60464 5.69865 2.472 8.314L2.475 8.317Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJouranl);
export default __webpack_public_path__ + "static/media/jouranl.22b8f64df144b323b708b3fe1dbfd541.svg";
export { ForwardRef as ReactComponent };